const DEBUG = false
export default async function waitFor(obj, prop) {
	while(!Object.prototype.hasOwnProperty.call(obj, prop)) {
		DEBUG && console.log("Checking %o on %o",prop,obj);
		await new Promise(resolve => setTimeout(resolve, 500));
	}
	DEBUG && console.log("got %o",prop);
	return obj[prop]
}
